import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "React Indie Bundle report, or how we made $31k in a week",
  "description": "",
  "published": "2015-12-18T00:00:00.000Z",
  "redirect_from": ["/blog/react-indie-bundle-report-or-how-we-made-31k-in-a-week/swizec/6762"],
  "categories": "Business, Click-through rate, Cyber Monday, Email marketing, Marketing, Side Projects",
  "hero": "./img/images-34905.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This past Cyber Monday, me and five other indie React.js authors got together and launched a bundle: 4 books, 19 hours of video, and a smattering of goodies and 1-on-1 consulting.`}</p>
    <p>{`A week later, sales closed. Here's how it went:`}</p>
    <p>{`We made 272 sales with an average value of $115 per sale. That amounts to exactly $31,323. It wasn't the runaway success we were hoping for, but at $4,250 per author (after the Facebook ad budget, the 10% donation we're making to open-source React.js projects, and Gumroad fees), it's nothing to sneeze at either. Hell, it's a cool grand more than I made from book sales in all of 2014 combined.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "800px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/2fec000fd81442d0a8ad15553e3e7520/5a190/images-34905.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.53363228699552%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'190\\'%20viewBox=\\'0%200%20400%20190\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M269%2058l-1%203v4l-1%203%201-3c2-2%202-2%202%202%201%203%200%204-3%208-4%205-5%206-4%203%200-2-1-1-2%201v4c1%202%203%201%204-1%200-2%205-9%206-9a1703%201703%200%200111%2087%20530%20530%200%2001-5-48l-5-41%204-5%204-6-4%204c-4%205-5%204-5-1l-1-5h-1m-11%2027l-2%203c2%202-2%2013-4%2011l-1%202%201%202a92%2092%200%2001-8%2031c1%203%203%203%204%200a215%20215%200%20019-36l1-8c3-5%202-7%200-5m-84%2019v2a338%20338%200%2001-12%2053c0%203%204%202%203-1l11-51c2-2%208%201%2012%205l3%202-2-5c0-2-1-2-3-2l-7-2-5-1m-59%2046c0%202%200%202-1%200%200-2-3-3-3%200h-1c0-1-1-2-7-2h-8v3c0%202%200%203%202%202v-2l2%201c1%201%201%201%202-1s1-2%201%200c1%203%2023%203%2023%200s-6-4-8-2c0%201-1%201-1-1-1-1-1-1-1%202m228-1c0%201%200%202-1%201%200-1-1-2-3-2l-2%201-2%201-1-1-1%201-1%201c0-2-1-3-3-3s-2%200-1%202v1h-1c0-2-4-4-5-2h-1l-1-1-1%203c0%202%200%202%201%201l1-1c1%202%204%203%204%201h1l4%201h2l2-1h16l2%201c2%200%202-1%202-3s0-3-2-2v3h-1c0-2-4-4-5-2l-2-1c-1-1-1-1-1%201m-201%2019l-3%206H86l-53%201h107l3-5%202-6-3%204\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2fec000fd81442d0a8ad15553e3e7520/ca0a1/images-34905.webp 223w", "/static/2fec000fd81442d0a8ad15553e3e7520/75680/images-34905.webp 445w", "/static/2fec000fd81442d0a8ad15553e3e7520/d00b9/images-34905.webp 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2fec000fd81442d0a8ad15553e3e7520/e92b6/images-34905.png 223w", "/static/2fec000fd81442d0a8ad15553e3e7520/e66bf/images-34905.png 445w", "/static/2fec000fd81442d0a8ad15553e3e7520/5a190/images-34905.png 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2fec000fd81442d0a8ad15553e3e7520/5a190/images-34905.png",
                "alt": "annotated-gumroad.png",
                "title": "annotated-gumroad.png",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`annotated-gumroad.png`}</figcaption>{`
  `}</figure></p>
    <p>{`By the numbers: our daily average was 24 sales and $2,847; our biggest sales day was just before closing at $5,922; and on our crappiest day in the core week, we made just $1,171.`}</p>
    <p>{`On any other day of the year, I'd kill for $1,171 in book sales.`}</p>
    <p>{`The React Indie Bundle was primarily a marketing experiment. People had already paid for constituent parts of the bundle in other places, so we knew that there was a market. The problem was that we had no idea how big that market was, how much of it we could reach, and what it would take for someone to go from `}<em parentName="p">{`"Hm, that's cool,"`}</em>{` to `}<em parentName="p">{`"SHUT UP AND TAKE MY MONEY."`}</em></p>
    <p>{`I don't know about you, but $59, $149, and $429 are not impulse buys for me…`}</p>
    <p>{`Thanks to a ton of hustle, we convinced 13,295 people to visit `}<a parentName="p" {...{
        "href": "http://www.reactindiebundle.com"
      }}>{`www.reactindiebundle.com`}</a>{` during the week, which means each unique visitor was worth about $2.35. I don't know if that's good or bad, but it creates a strong upper bound on the cost-per-click we can afford.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "800px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/38f7f27a950e8f73af4cba5e00fc96de/5a190/images-34906.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "31.838565022421527%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'127\\'%20viewBox=\\'0%200%20400%20127\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M211%2020c-2%203-2%204%200%201%201-1%202%200%207%207l6%209c0%201%2016%204%2024%204l12%201c4%201%206%201%2011-1%208-3%2019-2%2027%201l11%204%209%201a905%20905%200%200039-1c-47-1-51-1-61-6-7-3-17-3-25-1-6%202-7%202-12%201l-14-1c-15%200-18-1-25-11l-6-10c0-2-2-1-3%202m-34%2019l-3%206-3%201h-53l-9-2H75c-5-2-5-2-11%201-6%202-7%202-33%202L4%2048h28c25%200%2028%200%2032-2%205-2%206-2%2012%200%204%200%204%201-4%201l16%201%2017-1-8-1h8l11%201%2018%201h21a8771%208771%200%200020-2l2-6c4-8%203-9%200-1m156%2033c-18%207-23%2030-10%2043%2014%2014%2038%208%2044-10%206-21-14-40-34-33\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/38f7f27a950e8f73af4cba5e00fc96de/ca0a1/images-34906.webp 223w", "/static/38f7f27a950e8f73af4cba5e00fc96de/75680/images-34906.webp 445w", "/static/38f7f27a950e8f73af4cba5e00fc96de/d00b9/images-34906.webp 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/38f7f27a950e8f73af4cba5e00fc96de/e92b6/images-34906.png 223w", "/static/38f7f27a950e8f73af4cba5e00fc96de/e66bf/images-34906.png 445w", "/static/38f7f27a950e8f73af4cba5e00fc96de/5a190/images-34906.png 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/38f7f27a950e8f73af4cba5e00fc96de/5a190/images-34906.png",
                "alt": "annotated-google.png",
                "title": "annotated-google.png",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`annotated-google.png`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "marketing-experiments"
    }}>{`Marketing experiments`}</h2>
    <p>{`Our primary marketing channel was email, and our primary market was people who had either already purchased something from the bundle or had expressed interest in possibly doing so at some point.`}</p>
    <p>{`This strategy worked pretty well - email was our highest revenue generator. It didn't have the best conversion rates, but it more than made up for that with volume.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "345px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/26d23fac1f71d88bc57ff0b3a2b28c62/e4d6b/images-34907.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "173.99103139013454%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'696\\'%20viewBox=\\'0%200%20400%20696\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M6%2013l1%207%201-2c0-4%203-4%204%200l3%202v-4c-2-2-2-2%200-3%203-3%200-7-5-7H6v7m346%2073c-4%204%200%2010%204%207h4c3%202%205%201%205-3-1-7-6-8-6-2%200%201%200%202-1%201%200-2-3-5-4-5l-2%202M44%2088c-2%203%201%208%204%205%201-1%201-1-1-1l1-1c1-1%202%200%202%201%201%202%201%202%202%200%200-3%202-4%202-1l1%203%201-2%201-3%201%202%201%203%201-1h2c2%202%205%201%205-2%200-4-3-6-5-4v2c2-1%203%201%200%201l-1%201c-2-5-9-6-11-3h-1c0-2-3-2-5%200m15%2038c0%202%200%202-2%201-2-2-2-2-3-1l-3%201c-2-1-2%202-2%205h4c2%202%204%201%204-1l1-2%201%202c1%202%205%203%206%200h2c2%203%204%202%205-2l-1-3-1%203-1%202-1-2-1-3-1%201h-2l-2-1-1-1-1-2-1%203m15%2039v6c2%201%205%200%205-1h2c2%202%202%202%203%201h3c2%200%202%200%202-2l1-3%201%203%201%202%201-3c0-1%200-2%201-1l1%202%201%202v-6c-3-1-8-1-9%201l-2-1H74M6%20202c-3%204%201%2010%205%208l4-1h7l3%201c3-1%204-1%204%201%200%201%200%202%202%202s3-1%203-5c0-5%200-5-2-5l-4%202h-1l-3-2-3%202h-1c-1-2-5-2-6%200h-2l-2%201c0%202%200%202-2%202v-5h2c2%201%204%201%203-1H6m255%200c-3%203%201%2010%204%208l2-4c0-2%200-2%202-1s2%202%200%203v2l3-2h1l2%202c2-1%202-3%200-4-2%200-2%200%200-2l1-3-2%201-2%201c-1-2-4-2-4-1h-7m102%2039c-1%201-1%202%202%204l3%202h-3c-3-1-4%200-1%202%204%202%206-2%203-5v-2l2%201c0%201%201%202%203%202l2%201-2%201-2%201%202%201c2%201%202%201%204-1%203-5-1-11-5-7h-3c-2-2-3-2-5%200M53%20280l-2%201-2%201h-2c-2-2-5-1-4%201l-2-1c-3-3-6-1-6%202%200%204%204%205%206%203l1-1c1%203%206%202%206%200h1c3%204%206%202%206-4%200-4-1-5-2-2m201%200v5c-2%200-1%202%201%203%202%200%205-2%205-4%200-1%201-2%202-1%202%200%202%200%200%202l-1%203%202-1c1-2%201-2%203%200%201%202%204%201%204-2l-2-2c-2%200-2%200%200-2v-2l-1%201h-3c-2-2-2-2-3%200h-2c-1-2-3-2-5%200M58%20321c-1%202-1%202%201%204%201%202%202%202%203%201h10c2%200%202-1%202-3%200-3%201-2%202%202%201%201%201%201%201-1%200-3%202-4%202-1%200%202%201%203%202%203v-5c-1-2-8-2-9%200-1%201-1%201-3-1h-6c0-2-2-1-5%201m-26%2035v5c0%204%202%206%205%203h2c0%202%203%202%205%200h2c0%201%203%202%205%201%203-3%200-8-4-6h-8c0%202-1%202-1%201l-2-2-3-1-1-1m-19%203c-1%201%200%201%201%201l-1%201c-2%201-3%202-1%204%202%201%205%200%205-2l2%201c2%202%205%202%205%200h2l3%202c2-1%201-3%200-3h-3l2-1c3%200%204-1%201-3H19l-2%201c-1-2-4-3-4-1m237%2036c-2%201-3%206-1%208s5%201%206-1h1l3%202c4%200%205-5%202-8-2-2-2-2-4%200l-2%201c0-2-3-3-5-2M5%20399l1%205%201-1c0-3%202-2%203%200h7l-2-1c0-2%204-1%205%201%200%201%205%202%205%200l-2-1-1-1%201-2%202-1h-7c-1-2-4-1-5%202l-2%203v-4c0-3%200-4-3-4s-3%200-3%204m67-3c0%201-5%203-6%202l-3-1c-2%200-2%200-2%204l1%203%201-3c0-2%200-3%201-2l1%203%201%202%201-1h1c2%202%206%201%206-1h1c1%202%205%203%205%201h-1l-2-1c0-2%204-1%205%201l4%201c2%200%202%200%202-4l-1-5-1%201c0%201-5%203-6%202-1-2-4-1-5%201-1%201-1%201-1-1%200-3-2-5-2-2m-20%2016l-3%202-2-1-3-1c-2%202-1%203%201%202v1c-2%202-3%202-3%200-2-2-4-3-6-2h-2c-1%200-2%201-2%204%200%202%200%203%201%202%201-5%201-6%202-3s4%205%205%203l2-1c1%202%204%202%205%201%201-2%202-2%203%200%202%203%205%200%205-5v-4l-3%202m-19%2039h-2l-4%201-2%201c-1-2-3-2-5%200h-2c-1-2-3-2-5-1-1%202-1%202-3%200-3-2-5%200-5%205%201%205%205%205%206%201%200-3%200-3%202-1%201%202%204%203%205%200h2c2%202%204%202%205%201%200-2%202-1%202%201l2%202c3%200%204-2%204-6v-3l1%203c1%203%201%203%201-1l-1-5-1%202m13%2040c-2%202-1%205%201%206h3c1-2%202-2%203%200h6c2%200%202%200%202-2l1-3%201%203%201%202%201-3c0-1%200-2%201-1l1%202%201%202v-6H56c-2-1-5%200-5%203l-3%201c-2-1-1-3%201-3l2-1h-5M5%20530c-1%203%201%209%203%209s4-3%203-5h1c2%202%204%202%206%201h7c1-2%203%200%202%202%200%202%203%203%205%201s1-8-2-9l-3%201h-9c-2-1-4-1-6%201h-1c0-2-5-3-6-1m1%2038c-1%202%200%208%201%209%202%201%204%200%204-3%200-2%200-2%202-1%202%202%204%202%205%200h2c2%202%204%202%205%201%200-2%202-1%202%201s3%203%204%201c5-4%200-11-4-7h-2c0-2-3-2-5%200h-2c0-2-3-2-5%200l-2%201-2-2H6m243%2037c-2%202-1%207%201%208s2%201%204-1c1-2%201-2%203%200%202%203%205%202%206-2s-4-8-6-4h-3c-2-2-3-2-5-1M33%20644c0%201-1%202-2%201l-4%201-2%201c-1-2-3-2-5%200h-2c-1-2-3-2-5%200h-2c0-2-1-2-3-2s-2%201-2%205%200%205%202%205%203-1%203-3l1-2c0%202%204%203%205%202%201-2%202-2%204%200h3c2-2%203-2%203%201%200%202%203%203%205%201l1-5v-3l1%203c1%203%201%203%201-1l-1-5-1%201m1%2038v4c0%203%200%203-1%201-1-3-5-4-6-2h-9c-2-1-4-1-6%201h-1c0-2-1-2-3-2s-3%201-3%205c0%203%201%204%202%205%203%200%205-2%204-5l2%201c2%202%202%202%204%200h4c1%202%201%202%203%201%202-3%203-2%203%200%200%203%203%204%205%201l2-1%201-5c0-5%200-6-1-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/26d23fac1f71d88bc57ff0b3a2b28c62/ca0a1/images-34907.webp 223w", "/static/26d23fac1f71d88bc57ff0b3a2b28c62/50aa2/images-34907.webp 345w"],
                "sizes": "(max-width: 345px) 100vw, 345px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/26d23fac1f71d88bc57ff0b3a2b28c62/e92b6/images-34907.png 223w", "/static/26d23fac1f71d88bc57ff0b3a2b28c62/e4d6b/images-34907.png 345w"],
                "sizes": "(max-width: 345px) 100vw, 345px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/26d23fac1f71d88bc57ff0b3a2b28c62/e4d6b/images-34907.png",
                "alt": "sales-by-referrer.png",
                "title": "sales-by-referrer.png",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`sales-by-referrer.png`}</figcaption>{`
  `}</figure></p>
    <h3 {...{
      "id": "email-strategy"
    }}>{`Email strategy`}</h3>
    <p>{`We based our email marketing strategy on the idea of drip campaigns - sequences of emails that help you through the decision process.`}</p>
    <p>{`First, you get an email or two talking about general pros and cons of the technology. Ideally, you also learn something interesting. Then you get an email with a soft sell; we're still talking about benefits, but it's also urging you to make a purchase. In the end, you get an email with a hard sell.`}</p>
    <p>{`The idea is solid, but our execution was flawed.`}</p>
    <p>{`We floundered around because I ran out of time to prepare the sequence. I resorted to writing the sequence just-in-time; others resorted to email-blasting their followers.`}</p>
    <p>{`About 5,000 unique views came from the email campaigns. That's not bad, but considering we had a cumulative email list of some 40,000 people … it could have been better. We had a click-through rate of around 12%. I mean, that could be worse, right?`}</p>
    <p>{`Ok, here's the cool part:`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "800px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/2c215e7de3229f5192e12ecbe8ced871/5a190/images-34908.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "17.040358744394617%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'69\\'%20viewBox=\\'0%200%20400%2069\\'%20preserveAspectRatio=\\'none\\'/%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2c215e7de3229f5192e12ecbe8ced871/ca0a1/images-34908.webp 223w", "/static/2c215e7de3229f5192e12ecbe8ced871/75680/images-34908.webp 445w", "/static/2c215e7de3229f5192e12ecbe8ced871/d00b9/images-34908.webp 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2c215e7de3229f5192e12ecbe8ced871/e92b6/images-34908.png 223w", "/static/2c215e7de3229f5192e12ecbe8ced871/e66bf/images-34908.png 445w", "/static/2c215e7de3229f5192e12ecbe8ced871/5a190/images-34908.png 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2c215e7de3229f5192e12ecbe8ced871/5a190/images-34908.png",
                "alt": "drip-conversions.png",
                "title": "drip-conversions.png",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`drip-conversions.png`}</figcaption>{`
  `}</figure></p>
    <p>{`More than half of our sales volume came directly from emails I sent through `}<a parentName="p" {...{
        "href": "http://getdrip.com"
      }}>{`Drip`}</a>{`. $16,000 from nine emails sent to 1,186 qualified subscribers. That subscriber list started at 300 on Monday, and grew to 1,186 by the following Wednesday. That's about 100 new subscribers per day. Pretty cool, huh?`}</p>
    <p>{`Look at those numbers, man. When was the last time you got $1,777 for writing an email? I'm sitting here looking at these numbers, and I'm thinking, `}<em parentName="p">{`"Man, I need to write more emails ..."`}</em></p>
    <p>{`The real trick to those sales is what I call the "I'll buy it later" purchasing flow. I'm trademarking that. :)`}</p>
    <p>{`Nobody is going to buy your thing on impulse at these price points, so you don't ask them to. Instead, you say `}<em parentName="p">{`"Okay, you know what? Here's a free sample. Just give me your email address."`}</em>{` In exchange, you give them 4 book chapters and 42 minutes of video tutorials for free.`}</p>
    <p>{`Most people can get hella started with that, so they give you their email.`}</p>
    <p>{`They either look at the stuff, or they don't. If they do, that's awesome. The amazingness of your stuff will convince them to buy.`}</p>
    <p>{`The next day, you send them an email that teaches them something relevant or talks about an interesting fact or something else that's on-topic. The day after, they get another email. Then they get another.`}</p>
    <p>{`This builds an essential rapport. By the time that hard sell email comes, you're no longer a random guy on the internet who's trying to sell them something. You've become a trusted advisor and an expert. Maybe they've even exchanged some emails with you.`}</p>
    <p>{`Replying to your drip email has to work every time, and you have to respond `}<strong parentName="p">{`every time`}</strong>{`. Remember: you're a person, not a marketing drone.`}</p>
    <p>{`The highest converting email was the one where I didn't say anything at all. Instead, I quoted some of the replies I got to our purchase followup email that asked customers `}<em parentName="p">{`"Why did you buy the bundle?"`}</em>{`.`}</p>
    <p>{`Oh yeah. That's important, too. Don't just abandon people once they give you money. Follow-ups are important. If you ask the right questions, people will literally tell you what you need to write in your next book and how your sales copy should sound.`}</p>
    <h3 {...{
      "id": "other-things-we-tried"
    }}>{`Other things we tried`}</h3>
    <p>{`On top of sending a ton of emails and tweeting a bit, we tried four more things. Some worked better than others.`}</p>
    <p>{`On Saturday, two days before sales closed, we hosted a `}<strong parentName="p">{`webinar`}</strong>{`. This created the `}<em parentName="p">{`"Great, now we have two things to promote"`}</em>{` problem, but it worked out. Nearly 500 people signed up for the Google Hangout, and more than 100 showed up. Most of them decided to stay despite the 20 minutes of technical fuckups.`}</p>
    <p>{`We learned that just because it works when you test doesn't mean it will work five minutes later.`}</p>
    <p>{`I think there were only five direct sales from the webinar, but the connection and rapport we built with the community were invaluable. Just like those drip campaigns, the webinar built relationships and showed people that we know what we're talking about.`}</p>
    <p>{`One guy even replied to the follow-up email with `}<em parentName="p">{`"I bought the bundle because I liked your answers to questions in the webinar."`}</em></p>
    <p>{`When one person tells you something, ten others are thinking it, too.`}</p>
    <p>{`We also had some success `}<strong parentName="p">{`reaching out to specific communities`}</strong>{`. `}<a parentName="p" {...{
        "href": "http://reactjsnews.com"
      }}>{`ReactJSNews`}</a>{` tweeted about us, published our guest post, and put up a banner for the bundle. The `}<a parentName="p" {...{
        "href": "http://www.meetup.com/ReactJS-San-Francisco/"
      }}>{`SF React Meetup`}</a>{` sent an email about us to all of its members and published about us on their message board. JavaScript Daily tweeted about us, and we showed up in local communities in Finland, Poland, and Slovenia by reaching out to our personal connections.`}</p>
    <p><strong parentName="p">{`Facebook Ads`}</strong>{` worked great for generating some pretty expensive traffic. We burned through $1,124 in four days, and only got 980 website clicks to show for it. That's about $1.10 per click, or less than half of what the average visit was worth ($2.35).`}</p>
    <p>{`With FB Ads the reminder effect was more important than direct conversions and website clicks. We had a group of different ads running: some shared useful information, some counted down to sales ending, and some just said `}<em parentName="p">{`"Hey, this exists."`}</em></p>
    <p>{`If you have Facebook, and you visited `}<a parentName="p" {...{
        "href": "http://www.reactindiebundle.com"
      }}>{`reactindiebundle.com`}</a>{`, it was impossible for you to forget that this sale was happening. People literally tweeted screenshots of weird ad placements at me. We were even inside the Reddit app because Facebook is `}<em parentName="p">{`magic`}</em>{`.`}</p>
    <p>{`Many people commented in their replies to the follow-up email that those Facebook ads were a significant factor in their decision to buy. It was impossible to forget that the bundle was going on. It was always top of mind.`}</p>
    <p>{`Finally, we did a shitload of `}<strong parentName="p">{`content marketing`}</strong>{`. Most of the legwork came in the months before the bundle launched. Each author spent time building their own presence in the community by giving talks, publishing articles, and generally having a history. It's hard to pull off a bundle like this without having some legitimate history behind you.`}</p>
    <p>{`I have to say Juho was absolutely phenomenal during the week itself. Almost every day I would hear something to the note of `}<em parentName="p">{`"Okay my article got published in that thing over there."`}</em>{` It was pretty great.`}</p>
    <p>{`We didn't get a chance to fully leverage `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=5ry0RkD84RE"
      }}>{`Andrzej's unpacking video`}</a>{` or `}<a parentName="p" {...{
        "href": "https://vimeo.com/147565048"
      }}>{`Freddy's this-is-the-bundle video`}</a>{`, but they helped in convincing some people who were on the fence.`}</p>
    <p>{`Getting a bunch of free stuff is one thing, but getting `}<em parentName="p">{`guided`}</em>{` through that free stuff is something so much better.`}</p>
    <h2 {...{
      "id": "pricing-experiments"
    }}>{`Pricing experiments`}</h2>
    <p>{`None of that marketing would have mattered if our prices were off.`}</p>
    <p>{`We debated several approaches and in the end went with the classic "3 packages" solution. The reasoning is simple: people have preconceived ideas about how much your product is worth. This number has more to do with their feelings than it does with your product.`}</p>
    <p>{`Instead of wasting time trying to change people's minds, you sell three different products:`}</p>
    <ul>
      <li parentName="ul">{`First, you sell a low-price tier that satisfies everyone who is price-sensitive. You still price it high enough to discourage the bargain hunters (because they're bad for business). In our case, this was just the books.`}</li>
      <li parentName="ul">{`Then you have a middle tier. This is the highest bang-for-buck version of your product. It's cheap considering what people get, but it's priced high enough that you're making a sweet profit. In our case this option had the books, the videos, and 30 minutes of consulting. Plus some goodies.`}</li>
      <li parentName="ul">{`Then you have a magical high-price tier. This is where you throw in everything you've got. All of it. Absolutely everything. You give the most value you can ever hope to deliver. Most people will decide that the price is ridiculous and buy the middle tier. In our case, this tier had all the books, all the videos, 60 minutes of consulting, a 40% discount on a workshop, pair programming, and code review.`}</li>
    </ul>
    <p>{`This was everything we could offer, and it made the middle ground look super cheap.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "800px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/9145e7fe317f61d6348a72fcec792556/5a190/pricingpngfiafe1.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "15.695067264573993%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'63\\'%20viewBox=\\'0%200%20400%2063\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M5%205c0%202%200%203%204%203l5%201h1l9-1c5%200%207%200%206-1V5c2-1-4-2-10-1-3%201-4%200-4-1h-1c0%202%200%202-3%201-2-1-3-1-4%201H7L6%203C5%202%205%203%205%205\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9145e7fe317f61d6348a72fcec792556/ca0a1/pricingpngfiafe1.webp 223w", "/static/9145e7fe317f61d6348a72fcec792556/75680/pricingpngfiafe1.webp 445w", "/static/9145e7fe317f61d6348a72fcec792556/d00b9/pricingpngfiafe1.webp 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9145e7fe317f61d6348a72fcec792556/e92b6/pricingpngfiafe1.png 223w", "/static/9145e7fe317f61d6348a72fcec792556/e66bf/pricingpngfiafe1.png 445w", "/static/9145e7fe317f61d6348a72fcec792556/5a190/pricingpngfiafe1.png 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9145e7fe317f61d6348a72fcec792556/5a190/pricingpngfiafe1.png",
                "alt": "pricing.png",
                "title": "pricing.png",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`pricing.png`}</figcaption>{`
  `}</figure></p>
    <p>{`As you can see, the experiment worked. The middle tier generated the bulk of our sales volume - $21,605. The top and bottom tiers generated about a quarter of that each.`}</p>
    <p>{`But a lesson lurks in that screenshot. Can you see it?`}</p>
    <p>{`You'd expect the absolute number of sales for the middle tier to be less than the absolute number of sales for the low tier. The dollar value of the middle tier would still be higher, but the volume would be less.`}</p>
    <p>{`This implies two problems with our pricing:`}</p>
    <ol>
      <li parentName="ol">{`The low tier was too expensive and filtered out too many price-sensitive people.`}</li>
      <li parentName="ol">{`The middle tier was too cheap for what people were getting.`}</li>
    </ol>
    <p>{`We were leaving money on the table. Lesson learned.`}</p>
    <h2 {...{
      "id": "the-future"
    }}>{`The future`}</h2>
    <p>{`It's been over a week since sales closed, and the emails to the tune of `}<em parentName="p">{`"Omaigod! I forgot to buy this! Can I still get it?"`}</em>{` have stopped coming.`}</p>
    <p>{`We sold 96 hours of consulting, which is 16 hours per author. The logistics of handling those will probably take more time and mindshare than the consulting itself, but it's good practice and a good push for me to think about getting a virtual assistant.`}</p>
    <p>{`We've started scheduling the consulting hours, and they tie perfectly into answering the age-old question `}<em parentName="p">{`"What are people struggling with? How can I help?"`}</em>{`.`}</p>
    <p>{`Once Gumroad finishes sending the money, we'll figure out how to split the `}<strong parentName="p">{`\\`}{`\\`}{`\\`}{`$3,132 in donations`}</strong>{` between the open-source React.js projects we rely on daily. That's going to be a fun can of worms. Maybe we should offer it up to the popular vote…`}</p>
    <p>{`There might be another 1-day experiment on Christmas. I have some ideas. We'll see…`}</p>
    <p>{`If you want to know when that^ happens, `}<a parentName="p" {...{
        "href": "https://www.getdrip.com/forms/3974738/submissions/new"
      }}>{`leave us your email`}</a>{` and we'll ping you.`}</p>
    <p><strong parentName="p">{`Thanks`}</strong>{` to Juho Vepsäläinen, Freddy Rangel, and Will Fanguy for reading draft versions of this post.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      